import { Component, Input } from '@angular/core';
import {
	DadosRelatorioPluviometricoDiario,
	Relatorios,
} from '@home/submodulos/dados-meteorologicos/interfaces/tabela-relatorio';
import {
	ADTSettings,
	ADTColumns,
} from 'angular-datatables/src/models/settings';
import {
	isNotNuloOuUndefined,
	numberToBrNumber,
	renderCoordenada,
} from '@utils';
import { corrigeDuplicacaoNome } from '@home/submodulos/dados-meteorologicos/utils';

@Component({
	selector: 'seira-tabela-relatorio-pluv-diaria-personalizada',
	templateUrl: './tabela-relatorio-pluv-diaria-personalizada.component.html',
	styleUrls: ['./tabela-relatorio-pluv-diaria-personalizada.component.scss'],
})
export class TabelaRelatoriosDiariosComponent {
	private _relatorios: Relatorios<DadosRelatorioPluviometricoDiario>[] = [];
	dadosTabela: DadosRelatorioPluviometricoDiario[] = [];

	@Input()
	set relatorios(val: Relatorios<DadosRelatorioPluviometricoDiario>[]) {
		this._relatorios = val || [];
		this.atualizarDadosTabela();
	}
	get relatorios(): Relatorios<DadosRelatorioPluviometricoDiario>[] {
		return this._relatorios;
	}

	dtOptions: ADTSettings = {};

	private _colunasSelecionadas: string[] = [];

	@Input()
	set colunasSelecionadas(val: string[]) {
		this._colunasSelecionadas = val || [];
		this.atualizarColunasTabela();
	}
	get colunasSelecionadas(): string[] {
		return this._colunasSelecionadas;
	}

	colunas: ADTColumns[] = [];

	atualizarDadosTabela() {
		const dados: DadosRelatorioPluviometricoDiario[] = [];
		this.relatorios.forEach(relatorio => {
			relatorio.data.forEach(dado => {
				dados.push({
					...dado,
					posto: corrigeDuplicacaoNome(`${relatorio.municipio}/${dado.posto}`),
				});
			});
		});
		this.dadosTabela = dados;
	}

	atualizarColunasTabela() {
		const cols: ADTColumns[] = [
			{
				data: 'posto',
				title: 'Município/Posto',
				type: 'string',
				className: 'text-center',
			},
		];

		if (this.colunasSelecionadas.includes('Latitude')) {
			cols.push({
				data: 'latitude',
				title: 'Latitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value),
			});
		}
		if (this.colunasSelecionadas.includes('Longitude')) {
			cols.push({
				data: 'longitude',
				title: 'Longitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value),
			});
		}
		if (this.colunasSelecionadas.includes('Altitude')) {
			cols.push({
				data: 'altitude',
				title: 'Altitude',
				type: 'number',
				className: 'text-center',
				render: (value: string) => renderCoordenada(value, 1),
			});
		}
		if (this.colunasSelecionadas.includes('Microrregião')) {
			cols.push({
				data: 'microrregiao',
				title: 'Microrregião',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Mesorregião')) {
			cols.push({
				data: 'mesorregiao',
				title: 'Mesorregião',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Região Pluviométrica')) {
			cols.push({
				data: 'regiao',
				title: 'Região Pluviométrica',
				type: 'string',
				className: 'text-center',
			});
		}
		if (this.colunasSelecionadas.includes('Bacia/Sub-bacia')) {
			cols.push({
				data: 'bacia',
				title: 'Bacia/Sub-bacia',
				type: 'string',
				className: 'text-center',
			});
		}

		cols.push({
			data: 'mesAno',
			title: 'Data',
			type: 'string',
			className: 'text-center',
		});

		cols.push(
			...Array.from({ length: 31 }, (_, i) => ({
				data: `d${i + 1}`,
				title: `${String(i + 1).padStart(2, '0')}`,
				type: 'number',
				className: 'text-center',
				orderable: false,
				render: (precipitacao: number | null | undefined) =>
					isNotNuloOuUndefined(precipitacao)
						? numberToBrNumber(precipitacao, 1)
						: '-',
			}))
		);

		cols.push({
			data: 'total',
			title: 'Total',
			type: 'number',
			className: 'text-center',
			orderable: false,
			render: (precipitacaoAcumulada: number | null | undefined) =>
				isNotNuloOuUndefined(precipitacaoAcumulada)
					? numberToBrNumber(precipitacaoAcumulada, 1)
					: '-',
		});

		this.colunas = cols;
	}
}
